import { action, makeObservable } from 'mobx';

import { PopupStore } from '@/stores/local/shared/PopupStore';

type ConfirmPopupStoreParams = {
  onConfirm: (entityId: string) => Promise<void>;
};

export class ConfirmPopupStore extends PopupStore<{ id: number | string }> {
  private readonly _onConfirm: ConfirmPopupStoreParams['onConfirm'];

  constructor({ onConfirm }: ConfirmPopupStoreParams) {
    super();

    this._onConfirm = onConfirm;

    makeObservable(this, {
      confirm: action.bound,
    });
  }

  async confirm() {
    if (!this.entity) {
      return;
    }

    await this._onConfirm(String(this.entity.id));

    this.close();
  }
}
